import { Box, Typography, Button } from '@mui/material'
import BlockIcon from '@mui/icons-material/Block'
import { useTheme } from '@/contexts/ThemeContext'
import { useWallet } from '@/hooks/useWallet'
import { ConnectionStatus } from '@/constants/connectionStatus'

export default function AccessDenied() {
  const { status, disconnectWallet, address, formatAddress } = useWallet()
  const isConnected = status === ConnectionStatus.Connected
  const { colors } = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 100px)',
        textAlign: 'center',
        px: { xs: 2, sm: 4 },
      }}
    >
      <Box
        sx={{
          maxWidth: 600,
          p: 4,
          backgroundColor: colors.overlay,
          borderRadius: 3,
          border: `2px solid ${colors.error}`,
          boxShadow: `0 0 30px ${colors.error}33`,
        }}
      >
        <BlockIcon
          sx={{
            fontSize: 80,
            color: colors.error,
            mb: 3,
          }}
        />
        <Typography
          variant="h4"
          sx={{
            color: colors.error,
            fontWeight: 700,
            mb: 2,
            fontFamily: "'TWKEverett', sans-serif",
          }}
        >
          Access Denied
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: colors.text,
            fontSize: '18px',
            mb: 3,
            fontFamily: "'TWKEverett', sans-serif",
          }}
        >
          You do not have access to this dashboard.
        </Typography>
        {isConnected && address && (
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="body2"
              sx={{
                color: colors.text,
                opacity: 0.7,
                mb: 1,
              }}
            >
              Connected wallet:
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: colors.primary,
                fontFamily: 'monospace',
                fontWeight: 600,
              }}
            >
              {formatAddress(address)}
            </Typography>
          </Box>
        )}
        <Typography
          variant="body2"
          sx={{
            color: colors.text,
            opacity: 0.6,
            mb: 4,
          }}
        >
          Only administrators can access this system.
        </Typography>
        {isConnected && (
          <Button
            variant="outlined"
            onClick={disconnectWallet}
            sx={{
              borderColor: colors.error,
              color: colors.error,
              fontWeight: 600,
              px: 4,
              py: 1.5,
              '&:hover': {
                borderColor: colors.error,
                backgroundColor: `${colors.error}22`,
              },
            }}
          >
            Disconnect Wallet
          </Button>
        )}
      </Box>
    </Box>
  )
}
